import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M10 12.293L4.354 6.646l-.708.708L10 13.707l6.354-6.353-.707-.708L10 12.293z" /></svg>;